import { useColourTheme } from '@/ui/theme/ColourThemeContext';
import { SegmentedControl } from '../SegmentedControl';
import type { SettingControlProps } from '../types';

const THEME_OPTIONS = [
  { value: 'bright', label: 'Bright' },
  { value: 'dark', label: 'Dark' },
  { value: 'soft', label: 'Soft' },
] as const;

/** Segmented theme control. Applies and saves to `localStorage` immediately. */
export const ColourThemeControl = ({ labelId }: SettingControlProps) => {
  const { theme, setTheme } = useColourTheme();

  return <SegmentedControl labelId={labelId} options={THEME_OPTIONS} value={theme} onChange={setTheme} />;
};
